import { QUERY_LIST_SUCCESS, QUERY_DETAIL_SUCCESS, FETCH_START, FETCH_END, } from './ActionTypes';
import axios from '../../../../axios.conf';
import { history } from '../../../../components/Helpers';
import secureLocalStorage from 'react-secure-storage';

export const getQueryasListSuccess = (data) => {
  return {
    type: QUERY_LIST_SUCCESS,
    data,
  };
};

export const fetchStart = () => {
  return {
    type: FETCH_START,
  };
};

export const fetchEnd = () => {
  return {
    type: FETCH_END,
  };
};

export const getQueryasList = (pagination, limit) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getQueryasListAPI(pagination, limit)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getQueryasListSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getQueryasListAPI = (pagination, limit) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'sql-work-bench?page=' +
    pagination +
    '&limit=' +
    limit +
    '&application_type=' +
    sessionStorage.getItem('application'),
    { headers: headers },
  );
  return result;
};

export const submitQuery = (data, id, type) => {
  return (dispatch) => {
    return submitQueryAPI(data, id, type)
      .then((response) => {
        history.push('/query-field', { application: 'Data Insights' });
        return response;
      })
      .catch((error) => {
        //toast.error(error.response.data);
        throw error;
      });
  };
};

export const submitQueryAPI = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'put') {
    result = axios.put('sql-work-bench/' + id, data, { headers: headers });
  } else if (type === 'delete') {
    result = axios.delete('sql-work-bench/' + id, data, { headers: headers });
  } else {
    result = axios.post('sql-work-bench', data, { headers: headers });
  }
  return result;
};

//edit formula
export const getQueryDetails = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getQueryDetailsAPI(id)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getQueryDetailsSuccess(response.data.response));
        //history.push('/query-field/edit-query-field/' + id);
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getQueryDetailsAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('sql-work-bench/' + id, { headers: headers });
  return result;
};

export const getQueryDetailsSuccess = (data) => {
  return {
    type: QUERY_DETAIL_SUCCESS,
    data,
  };
};
